import type { KundenRechnung } from "@/lib/mahnwesen";

export type KundenRechnungSort = "datum" | "objektadresse" | "nummer";

function datumKey(value: string | null | undefined): string {
  return value || "";
}

function textKey(value: string | null | undefined): string {
  return (value || "").trim().toLocaleLowerCase("de");
}

export function distinctObjektadressen(rows: KundenRechnung[]): string[] {
  const seen = new Set<string>();
  for (const row of rows) {
    const adresse = (row.objektadresse || "").trim();
    if (adresse) seen.add(adresse);
  }
  return [...seen].sort((a, b) => a.localeCompare(b, "de"));
}

export function filterKundenRechnungen(
  rows: KundenRechnung[],
  objektadresse: string,
): KundenRechnung[] {
  const wanted = objektadresse.trim();
  if (!wanted) return rows;
  return rows.filter((row) => (row.objektadresse || "").trim() === wanted);
}

export function sortKundenRechnungen(
  rows: KundenRechnung[],
  sort: KundenRechnungSort,
): KundenRechnung[] {
  const copy = [...rows];
  copy.sort((a, b) => {
    if (sort === "objektadresse") {
      const aEmpty = !textKey(a.objektadresse);
      const bEmpty = !textKey(b.objektadresse);
      if (aEmpty !== bEmpty) return aEmpty ? 1 : -1;
      const byAdresse = textKey(a.objektadresse).localeCompare(textKey(b.objektadresse), "de");
      if (byAdresse !== 0) return byAdresse;
      return datumKey(b.belegdatum).localeCompare(datumKey(a.belegdatum));
    }
    if (sort === "nummer") {
      const byNummer = textKey(b.dokument_nummer).localeCompare(textKey(a.dokument_nummer), "de", {
        numeric: true,
      });
      if (byNummer !== 0) return byNummer;
      return datumKey(b.belegdatum).localeCompare(datumKey(a.belegdatum));
    }
    const byDatum = datumKey(b.belegdatum).localeCompare(datumKey(a.belegdatum));
    if (byDatum !== 0) return byDatum;
    return textKey(a.objektadresse).localeCompare(textKey(b.objektadresse), "de");
  });
  return copy;
}
